<template>
  <div class="default-layout">

    <header>
      <img src="@/assets/images/header-logos.jpg" alt="SmartAC ABC Logo">
    </header>
    <main>
      <div class="page-header">
        <!-- <p class="eyebrow">Discover our product</p> -->
        <h1>What is <br/> SmartAC.com</h1>
      </div>

      <section class="fullwidth">
        <span class="wistia_embed wistia_async_kkd0qafm65 popover=true popoverAnimateThumbnail=true popoverShowOnLoad=true">&nbsp;</span>
      </section>

      <section class="fullwidth">
        <img src="@/assets/images/smarthub-table-plant.jpg" alt="Hub">
        <img src="@/assets/images/comfort-sensor-closeup-vent.jpg" alt="Comfort sensor on vent" class="mt-4">
      </section>

      <section>
        <ul>
          <li><img src="@/assets/images/list-item-bullet.png" alt="list-bullet" class="bullet">Predicts breakdowns before they happen</li>
          <li><img src="@/assets/images/list-item-bullet.png" alt="list-bullet" class="bullet">Catches small problems before they become expensive</li>
          <li><img src="@/assets/images/list-item-bullet.png" alt="list-bullet" class="bullet">Detects water leaks before catastrophic damage</li>
          <li><img src="@/assets/images/list-item-bullet.png" alt="list-bullet" class="bullet">Tracks filter health percentage to optimize replacements</li>
          <li><img src="@/assets/images/list-item-bullet.png" alt="list-bullet" class="bullet">Monitors HVAC system health through real-time data</li>
          <li><img src="@/assets/images/list-item-bullet.png" alt="list-bullet" class="bullet">Provides transparency on what needs to be fixed</li>
        </ul>
      </section>

      <section class="fullwidth">
        <img src="@/assets/images/filter-sensor-vent.jpg" alt="filter sensor in vent">
      </section>

      <section>
        <FeatureList/>
      </section>

      <section class="fullwidth">
        <img src="@/assets/images/water-sensor-drain-pan.jpg" alt="water sensor in drain pan">
        <img src="@/assets/images/sensor-group.jpg" alt="sensors back" class="my-4">
        <img src="@/assets/images/app-key-screenshots.jpg" alt="key app screenshots">
      </section>

    </main>

    <Footer/>
  </div>
</template>

<script>
    import Footer from '@/components/Footer.vue'
    import FeatureList from '@/components/FeatureList.vue'
    export default {
        components: {
            Footer,
            FeatureList,
        }
    }
</script>